import { UnicornQuotas } from '../../shared/interfaces/unicorn.interface';
import { SurveyQuotas } from './survey-quotas';

export class SurveyUnicorns {
  constructor(private _surveyUnicorns: UnicornQuotas[]) {}

  hasQualification(qualificationId: number): boolean {
    return new SurveyQuotas(this._surveyUnicorns).hasQualification(
      qualificationId
    );
  }

  hasQuota(buyerQuotaId: string) {
    return new SurveyQuotas(this._surveyUnicorns).hasQuota(buyerQuotaId);
  }
}
